import React from 'react';
import {BusinessMenu} from './menu';
import style from './style.scss'

class BusinessLayout extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      active: ''
    }
  }

  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  render() {
    return (
      <section className='center'>
        <div className="business-layout">
          <div className='business-layout-left-menu'>
            <div className='business-layout-left'>
              <BusinessMenu active={this.props.active}/>
            </div>
          </div>
          <div className='business-layout-right-content'>
            {
              this.props.children
            }
          </div>
        </div>
      </section>
    );
  }
}

export default BusinessLayout;



// WEBPACK FOOTER //
// ./components/layouts/business/BusinessLayout.jsx